<template>
  <div class="cookie-bar">
    <cookie-law theme="cookie-bar" buttonText="CLOSE AND CONTINUE" buttonClass="btn_orange" >
      <div slot="message">
        As you might imagine, this site uses cookies. If you continue to use this site, it means you’re ok with that. If you’d like to learn more about our cookie policy (and we know you can’t wait to do that), <a href="/privacy" title="Privacy">click here.</a>
      </div>
    </cookie-law>
  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law';

export default {
  name:'cookieBar',
  components: {
    CookieLaw
  }
}
</script>



// WEBPACK FOOTER //
// cookie-bar.vue?fb0dd2f2